import { createStore } from 'vuex'

import event from './module/event'

export default new createStore({
  modules: {
  event
  },
});